(() => {
  const config = window.AromaSociety || {};
  const body = document.body;
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const searchDialog = document.querySelector('[data-search-dialog]');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartCount = document.querySelector('[data-cart-count]');
  const cartRecommendations = document.querySelector('.cart-drawer__recommendations');

  const formatMoney = (cents) =>
    `${new Intl.NumberFormat('ro-RO', {
      maximumFractionDigits: 2,
    }).format(Number(cents || 0) / 100)} lei`;

  const escapeHtml = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const lockBody = () => {
    const hasOpenPanel = [mobileDrawer, cartDrawer, searchDialog].some(
      (panel) => panel && !panel.hidden,
    );
    body.classList.toggle('is-locked', hasOpenPanel);
  };

  const setPanel = (panel, open) => {
    if (!panel) return;
    panel.hidden = !open;
    lockBody();
  };

  const closePanels = () => {
    setPanel(mobileDrawer, false);
    setPanel(cartDrawer, false);
    setPanel(searchDialog, false);
  };

  const notify = (message) => {
    let toast = document.querySelector('[data-shop-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'shop-toast';
      toast.dataset.shopToast = '';
      document.body.append(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._hideTimer);
    toast._hideTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  document.querySelector('[data-mobile-open]')?.addEventListener('click', () => setPanel(mobileDrawer, true));
  document.querySelector('[data-mobile-close]')?.addEventListener('click', () => setPanel(mobileDrawer, false));
  document.querySelector('[data-search-open]')?.addEventListener('click', () => {
    setPanel(searchDialog, true);
    window.setTimeout(() => document.querySelector('[data-search-input]')?.focus(), 30);
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => setPanel(searchDialog, false));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => setPanel(cartDrawer, false));

  [mobileDrawer, cartDrawer].forEach((overlay) => {
    overlay?.addEventListener('click', (event) => {
      if (event.target === overlay) setPanel(overlay, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  mobileDrawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setPanel(mobileDrawer, false));
  });

  const cartAsset = (item) => config.assets?.[item.handle] || item.image || '';

  const renderCart = (cart) => {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.hidden = cart.item_count === 0;
    }

    if (!cartBody) return;
    if (!cart.items.length) {
      if (cartRecommendations) cartRecommendations.hidden = true;
      cartBody.innerHTML = `
        <div class="drawer-empty">
          <h3>Coșul tău este gol.</h3>
          <p>Începe cu produsul sau setul care se potrivește ritualului tău.</p>
          <a class="button button--dark" href="/#magazin">Vezi produsele</a>
        </div>`;
      return;
    }

    if (cartRecommendations) cartRecommendations.hidden = false;

    const lines = cart.items
      .map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p>${escapeHtml(item.variant_title)}</p>`
          : '';
        return `
          <article class="drawer-cart-line">
            <a href="${escapeHtml(item.url)}"><img src="${escapeHtml(cartAsset(item))}" alt=""></a>
            <div>
              <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
              ${variant}
              <p>Cantitate: ${item.quantity}</p>
              <button type="button" data-cart-remove="${escapeHtml(item.key)}">Elimină</button>
            </div>
            <strong>${formatMoney(item.final_line_price)}</strong>
          </article>`;
      })
      .join('');

    const freeShippingThreshold = Number(config.freeShippingThreshold || 25000);
    const shippingRemaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const shippingProgress = Math.min(100, Math.round((cart.total_price / freeShippingThreshold) * 100));
    const shippingMessage = shippingRemaining > 0
      ? `Mai ai ${formatMoney(shippingRemaining)} până la livrarea gratuită.`
      : 'Ai deblocat livrarea gratuită.';

    cartBody.innerHTML = `
      <div class="drawer-cart-lines">${lines}</div>
      <div class="drawer-cart-footer">
        <div class="drawer-shipping"><span>${shippingMessage}</span><i><b style="width:${shippingProgress}%"></b></i></div>
        <div><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div>
        <p>Taxele și livrarea se calculează la checkout.</p>
        <a class="button button--coral button--full" href="${escapeHtml(config.cartUrl || '/cart')}">Continuă la checkout</a>
      </div>`;

    cartBody.querySelectorAll('[data-cart-remove]').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const response = await fetch(`${config.cartChangeUrl || '/cart/change'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: button.dataset.cartRemove, quantity: 0 }),
          });
          if (!response.ok) throw new Error('Cart update failed');
          renderCart(await response.json());
        } catch {
          notify('Coșul nu a putut fi actualizat. Încearcă din nou.');
          button.disabled = false;
        }
      });
    });
  };

  const refreshCart = async () => {
    if (cartBody) cartBody.innerHTML = '<div class="drawer-loading">Se încarcă...</div>';
    const response = await fetch(config.cartJsonUrl || '/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart load failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.querySelector('[data-cart-open]')?.addEventListener('click', async () => {
    setPanel(cartDrawer, true);
    try {
      await refreshCart();
    } catch {
      notify('Coșul nu a putut fi încărcat.');
    }
  });

  document.querySelectorAll('form[data-ajax-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const originalText = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = 'Se adaugă...';
      }

      try {
        const response = await fetch(`${config.cartAddUrl || '/cart/add'}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Add failed');
        }
        await response.json();
        await refreshCart();
        setPanel(cartDrawer, true);
      } catch (error) {
        notify(error.message || 'Produsul nu a putut fi adăugat.');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  });

  const filterButtons = document.querySelectorAll('[data-category-filter]');
  const productCards = document.querySelectorAll('[data-product-category]');
  const catalogCount = document.querySelector('[data-catalog-count]');
  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.categoryFilter;
      let visible = 0;
      filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      productCards.forEach((card) => {
        const show = filter === 'all' || card.dataset.productCategory === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (catalogCount) catalogCount.textContent = `${visible} ${visible === 1 ? 'produs' : 'produse'}`;
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    let variants = [];
    try {
      variants = JSON.parse(section.dataset.productVariants || '[]');
    } catch {
      variants = [];
    }

    const optionSelects = [...section.querySelectorAll('[data-product-option]')];
    const optionButtons = [...section.querySelectorAll('[data-option-button]')];
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-product-compare-price]');
    const stock = section.querySelector('[data-product-stock]');
    const addButton = section.querySelector('[data-add-button]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const productForm = section.querySelector('.pdp-form');

    const updateScentProfile = () => {
      const scentSelect = optionSelects.find((select) => {
        const fieldset = select.closest('[data-option-fieldset]');
        return fieldset?.textContent.toLowerCase().includes('parfum');
      });
      if (!scentSelect) return;
      document.querySelectorAll('[data-scent-profile]').forEach((profile) => {
        profile.classList.toggle('is-active', profile.dataset.scentProfile === scentSelect.value);
      });
    };

    const updateVariant = () => {
      const selectedOptions = optionSelects.map((select) => select.value);
      const variant = variants.find((candidate) =>
        candidate.options.every((option, index) => option === selectedOptions[index]),
      );
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (comparePrice) {
        const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      }
      if (stock) {
        stock.textContent = variant.available ? 'În stoc' : 'Indisponibil';
        stock.classList.toggle('is-out', !variant.available);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Adaugă în coș' : 'Indisponibil';
      }
      if (stickyAdd) stickyAdd.disabled = !variant.available;

      optionButtons.forEach((button) => {
        const position = Number(button.dataset.optionPosition || 0);
        const active = selectedOptions[position - 1] === button.dataset.optionValue;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      updateScentProfile();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const select = optionSelects.find(
          (item) => Number(item.dataset.optionPosition) === Number(button.dataset.optionPosition),
        );
        if (!select) return;
        select.value = button.dataset.optionValue;
        updateVariant();
      });
    });
    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));

    const sellingPlan = section.querySelector('[data-selling-plan]');
    section.querySelectorAll('input[name="purchase_mode"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (sellingPlan) sellingPlan.disabled = radio.value !== 'subscription';
        section.querySelectorAll('.purchase-card').forEach((card) => {
          card.classList.toggle('is-active', card.contains(radio));
        });
      });
    });

    stickyAdd?.addEventListener('click', () => productForm?.requestSubmit());
    updateVariant();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    thumbnails.forEach((button) => {
      button.addEventListener('click', () => {
        if (mainImage) mainImage.src = button.dataset.gallerySrc;
        thumbnails.forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });
  });

  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[data-product-tab]')];
    const panels = [...tabs.querySelectorAll('[data-product-panel]')];
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => {
          const active = panel.dataset.productPanel === button.dataset.productTab;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });
  });

  document.querySelectorAll('[data-collection-page]').forEach((collectionPage) => {
    const categoryButtons = [...collectionPage.querySelectorAll('[data-collection-filter]')];
    const scentButtons = [...collectionPage.querySelectorAll('[data-scent-filter]')];
    const cards = [...collectionPage.querySelectorAll('[data-collection-product]')];
    const count = collectionPage.querySelector('[data-collection-count]');
    const empty = collectionPage.querySelector('[data-collection-empty]');
    let category = 'all';
    let scent = 'all';

    const applyCollectionFilters = () => {
      let visible = 0;
      cards.forEach((card) => {
        const categoryMatch = category === 'all' || card.dataset.category === category;
        const scentMatch = scent === 'all' || card.dataset.scented === 'true';
        const show = categoryMatch && scentMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? 'produs' : 'produse'}`;
      if (empty) empty.hidden = visible !== 0;
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.collectionFilter;
        categoryButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        applyCollectionFilters();
      });
    });
    scentButtons.forEach((button) => {
      button.addEventListener('click', () => {
        scent = button.dataset.scentFilter;
        scentButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        applyCollectionFilters();
      });
    });
    collectionPage.querySelector('[data-collection-reset]')?.addEventListener('click', () => {
      category = 'all';
      scent = 'all';
      categoryButtons.forEach((item) => item.classList.toggle('is-active', item.dataset.collectionFilter === 'all'));
      scentButtons.forEach((item) => item.classList.toggle('is-active', item.dataset.scentFilter === 'all'));
      applyCollectionFilters();
    });
    collectionPage.querySelector('[data-collection-sort]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-faq-page]').forEach((faqPage) => {
    const filters = [...faqPage.querySelectorAll('[data-faq-filter]')];
    const groups = [...faqPage.querySelectorAll('[data-faq-category]')];
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.faqFilter;
        filters.forEach((item) => item.classList.toggle('is-active', item === button));
        groups.forEach((group) => {
          group.hidden = filter !== 'all' && group.dataset.faqCategory !== filter;
        });
      });
    });
  });

  const quizProfiles = {
    'Neroli 02': { number: '02', mood: 'Luminos, curat și magnetic.', notes: 'Neroli · bergamotă · mosc curat' },
    'Figue Noire 04': { number: '04', mood: 'Cald, catifelat și neașteptat.', notes: 'Frunză de smochin · iris · cedru' },
    'Cedru 07': { number: '07', mood: 'Verde, mineral și liniștit.', notes: 'Ienupăr · cedru · vetiver' },
    'Safran 08': { number: '08', mood: 'Condimentat, mătăsos și dens.', notes: 'Șofran · trandafir · ambră' },
    'Rose Vetiver 10': { number: '10', mood: 'Floral, verde și sofisticat.', notes: 'Petale · geranium · vetiver' },
    'Bergamote 11': { number: '11', mood: 'Citrice, ceai și lumină.', notes: 'Bergamotă · ceai verde · lemn alb' },
    'Patchouli Marin 12': { number: '12', mood: 'Mineral, sărat și vibrant.', notes: 'Sare marină · salvie · patchouli' },
  };

  document.querySelectorAll('[data-scent-quiz]').forEach((quiz) => {
    const screens = [...quiz.querySelectorAll('[data-quiz-screen]')];
    const scores = Object.fromEntries(Object.keys(quizProfiles).map((name) => [name, 0]));
    let step = 0;

    const showScreen = (name) => {
      screens.forEach((screen) => {
        const active = screen.dataset.quizScreen === String(name);
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
      });
    };
    const resetQuiz = () => {
      Object.keys(scores).forEach((name) => { scores[name] = 0; });
      step = 0;
      showScreen('intro');
    };
    const showResult = () => {
      const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0];
      const profile = quizProfiles[winner];
      quiz.querySelector('[data-quiz-result-name]').textContent = winner;
      quiz.querySelector('[data-quiz-result-number]').textContent = profile.number;
      quiz.querySelector('[data-quiz-result-mood]').textContent = profile.mood;
      quiz.querySelector('[data-quiz-result-notes]').textContent = profile.notes;
      const tagInput = quiz.querySelector('[data-quiz-result-tag]');
      if (tagInput) tagInput.value = `quiz-parfum, club-aroma, rezultat-${winner}`;
      showScreen('result');
    };

    quiz.querySelector('[data-quiz-start]')?.addEventListener('click', () => {
      step = 1;
      showScreen(step);
    });
    quiz.querySelectorAll('[data-quiz-answer]').forEach((answer) => {
      answer.addEventListener('click', () => {
        String(answer.dataset.quizPoints || '').split(',').forEach((name, index) => {
          if (name in scores) scores[name] += index === 0 ? 2 : 1;
        });
        step += 1;
        if (step > 3) showResult();
        else showScreen(step);
      });
    });
    quiz.querySelector('[data-quiz-restart]')?.addEventListener('click', resetQuiz);
  });
})();
